import React from "react";

import type { AppointmentSlot } from "@/lib/types/schedule";

import { AppointmentButton } from "./AppointmentButton";

type MakeTimeSlotButtonProps = {
  selectedAppointment: Nullable<AppointmentSlot>;
  setSelectedAppointment: (appointment: Nullable<AppointmentSlot>) => void;
  slot: Nullable<AppointmentSlot>;
};

export const MakeTimeSlotButton = ({
  selectedAppointment,
  setSelectedAppointment,
  slot,
}: MakeTimeSlotButtonProps) => {
  if (!slot)
    return (
      <div className="tw:min-w-31.25 tw:border tw:!border-transparent tw:py-1 tw:leading-5 tw:text-text-tertiary">
        –
      </div>
    );

  const isSelected = slot === selectedAppointment;

  return (
    <AppointmentButton
      isSelected={isSelected}
      className="tw:flex tw:gap-0.5 tw:justify-center tw:font-bold tw:text-nowrap"
      onPress={() => {
        setSelectedAppointment(slot);
      }}
      startTime={slot.start_time}
      endTime={slot.end_time}
    />
  );
};
